module.exports = __webpack_public_path__ + "img/sala-espera.c68ec232.jpeg";